module.exports = __webpack_public_path__ + "static/media/staff.3df9ab8a.svg";